/**
 * NOTE:
 * to add additional POST body payload,
 * use additionalPayload key, all the properties
 * will be merged with the default payload
 * Dikonfirmasi: [
 *   {
 *     status: status.CANCELED,
 *     customModalTransition: TransitionToCancelModal,
 *   },
 * ],
 */

export default {
  computed: {
    status() {
      return {
        DRAFT: { id: 'DRAFT', name: this.$t('costManagement.status.draft'), code: 'Draf' },
        CONFIRMED: { id: 'CONFIRMED', name: this.$t('costManagement.status.confirmed'), code: 'Dikonfirmasi' }
      }
    },
    statusTransitions() {
      return {
        /* DRAFT */
        Draf: [{ status: this.status.CONFIRMED }],
      
        /* CONFIRMED */
        Dikonfirmasi: [],
      }
    }
  }
}
